// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"6e6fda44","112":"600ade4e","258":"8a6feae9","377":"3095d59e","417":"cb8f86fe","467":"f30ce5b8","626":"d480170c","870":"f696c1fd"}[chunkId] + ".js";
};